/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { useState, useEffect } from "react"
import styled from "styled-components"
import { useForm } from "react-hook-form"
import { useLazyQuery, useMutation } from "@apollo/client"
import {
  InputDatePicker,
  InputNumber,
  InputSelect,
  InputText,
  InputTime,
  ModalForm
} from "../components/form"
import {
  divisas,
  estatus,
  nombreCliente,
  ramos
} from "../constants/newContract"
// import Button from "../components/ui/Button";
import {
  CREATE_CONTRACT,
  GET_COMPANIES,
  GET_TYPES_COINS,
  GET_CONTRACTS_STATUS,
  GET_RAMOS,
  CREATE_CLIENT
} from "../services/contract/contracts"
import { GET_ALL_CLIENTS } from "../services/clients"
import { Button } from "../components/ui"
import Navbar from "../components/Nabvar"
import Footer from "../components/Footer"
import { CheckOutlinedIcon, ErrorOutlinedIcon } from "../assets/icons/Icons"
import { useContract } from "../redux/contractReducer"
import { useNavigate } from "react-router-dom"
import { manageError } from "../helpers/errors"
// import { ModalWrapper } from "../components/ui/ModalWrapper";
import ModalContainer from "../components/ModalContainer"

export default function NewContractPage() {
  const [allDataInputs, setAllDataInputs] = useState([])

  const [showModal, setShowModal] = useState(false)

  const [selectCreatedClient, setSelectCreatedClient] = useState(null)

  const [clientCreated, setClientCreated] = useState({
    view: false,
    created: false,
    customMessage: undefined
  })

  const [contractCreated, setContractCreated] = useState({
    view: false,
    created: false,
    customMessage: undefined
  })

  const { setContract } = useContract()
  const navigate = useNavigate()
  // FORM //
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setError
  } = useForm({})

  // NUEVO CLIENTE MODAL FORM //
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    control: control2,
    formState: { errors: errors2 }
  } = useForm({})

  // Queries
  const [getClients] = useLazyQuery(GET_ALL_CLIENTS, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "no-cache",
    onCompleted({ getAllClients }) {
      if (getAllClients.statusCode === 200) {
        const result = JSON.parse(getAllClients.response)
        const filtered = allDataInputs.map((data) =>
          data.filter((input) => input.titleNameArr !== "cliente_id")
        )
        const dataOptionClient = result.map((cliente) => ({
          titleNameArr: "cliente_id",
          label: cliente.nombre,
          value: cliente.cliente_id
        }))
        setAllDataInputs(() => [...filtered, dataOptionClient])
      }
    },
    onError(err) {
      console.log("Error: ", err)
    }
  })

  const [getCompany] = useLazyQuery(GET_COMPANIES, {
    fetchPolicy: "network-only",
    onCompleted({ getCompany }) {
      if (getCompany.statusCode === 200) {
        const result = JSON.parse(getCompany.response)
        const dataOptionClient = result.map((cliente) => ({
          titleNameArr: "empresa_id",
          label: cliente.nombre,
          value: cliente.empresa_id
        }))
        setAllDataInputs((data) => [...data, dataOptionClient])
      }
    },
    onError(err) {
      console.log("Error: ", err)
    }
  })

  const [getTypesCoins] = useLazyQuery(GET_TYPES_COINS, {
    fetchPolicy: "network-only",
    onCompleted({ getTypeCoin }) {
      if (getTypeCoin.statusCode === 200) {
        const result = JSON.parse(getTypeCoin.response)
        const dataOptionClient = result.map((cliente) => ({
          titleNameArr: "tipo_cambio_id",
          label: cliente.valor,
          value: cliente.tipo_cambio_id
        }))
        setAllDataInputs((data) => [...data, dataOptionClient])
      }
    },
    onError(err) {
      console.log("Error: ", err)
    }
  })

  const [getContractStatus] = useLazyQuery(GET_CONTRACTS_STATUS, {
    fetchPolicy: "network-only",
    onCompleted({ getContractStatus }) {
      if (getContractStatus.statusCode === 200) {
        const result = JSON.parse(getContractStatus.response)
        const dataOptionClient = result.map((cliente) => ({
          titleNameArr: "estatus_contrato_id",
          label: cliente.valor,
          value: cliente.estatus_contrato_id
        }))
        setAllDataInputs((data) => [...data, dataOptionClient])
      }
    },
    onError(err) {
      console.log("Error: ", err)
    }
  })

  const [getRamos] = useLazyQuery(GET_RAMOS, {
    fetchPolicy: "network-only",
    onCompleted({ getRamos }) {
      if (getRamos.statusCode === 200) {
        const result = JSON.parse(getRamos.response)
        const dataOptionClient = result.map((cliente) => ({
          titleNameArr: "ramo_id",
          label: cliente.valor,
          value: cliente.ramo_id
        }))
        setAllDataInputs((data) => [...data, dataOptionClient])
      }
    },
    onError(err) {
      console.log("Error: ", err)
    }
  })

  // Mutations
  const [createContract, resultContract] = useMutation(CREATE_CONTRACT, {
    onCompleted({ createContract }) {
      console.log(createContract);
      if (createContract.statusCode === 200) {
        console.log("200");
        const contract = JSON.parse(createContract.response)
        setContract({...contract[0], siniester: true})
       if (createContract.response[0]){
        //setContract(JSON.parse(createContract.response)[0])
        navigate("/captura-siniestro", { replace: true })
       }

      } else if (createContract.statusCode === 422) {
        
        setShowModal(false)
      }
    },
    onError({ graphQLErrors }) {
      const errors = manageError(graphQLErrors)
      if (errors) {
        errors.forEach((error) => {
          let field = error.field
          field = field === "nombre" ? "numeroContrato" : field
          setError(field, { type: error.message })
        })
      }
    }
  })

  const [createClient] = useMutation(CREATE_CLIENT, {
    onCompleted({ createClient }) {
      if (createClient.statusCode === 200) {
        // alert("Cliente agregado :D");
        setShowModal(false)
        setClientCreated({ view: true, created: true })
        // setTimeout(() => {
        //   setClientCreated({ view: false, created: true });
        // }, [3500]);
        // const cliente = JSON.parse(createClient.response).nombre;
        const cliente = JSON.parse(createClient.response).cliente_id
        setSelectCreatedClient(cliente)
      } else if (createClient.statusCode === 422) {
        setClientCreated({
          view: true,
          created: false,
          customMessage: "El cliente ya existe"
        })
        // setTimeout(() => {
        //   setClientCreated({ view: false, created: true, customMessage: "" });
        // }, [3500]);
        setShowModal(false)
      }
    },
    onError(err) {
      console.log(err)
      setShowModal(false)
      setClientCreated({ view: true, created: false })
      setTimeout(() => {
        setClientCreated(false)
      }, [3500])
    }
  })
  useEffect(() => {
    reset({
      cliente_id: selectCreatedClient
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCreatedClient])
  // Creando contrato
  const mergeDates = (date, time) => {
    return `${date.toString().slice(0, 15)} ${time.toString().slice(16)}`
  }

  mergeDates(Date.now(), Date.now())
  const onSubmit = (data) => {
    const contractInput = {
      input: {
        nombre: `${data.numeroContrato}`,
        fecha_ini: `${mergeDates(data.fecha_ini, data.inicioHoraVigencia)}`,
        fecha_fin: `${mergeDates(data.fecha_fin, data.finalHoraVigencia)}`,
        fecha_emi: `${data.fecha_emi}`,
        sum: data.sum,
        porcentaje: data.porcentaje,
        tipo_cambio_id: data.tipo_cambio_id,
        empresa_id: 2,
        cliente_id: data.cliente_id,
        ramo_id: data.ramo_id,
        estatus_contrato_id: data.estatus_contrato_id
      }
    }
    console.log({ contractInput })
    createContract({
      variables: contractInput
    })
    console.log("test");
  }
  const onSubmitModal = async (data) => {
    const clientInput = {
      nombre: data.nombre
    }
    await createClient({
      variables: clientInput
    })
    await getClients()
    setShowModal(false)
  }
  useEffect(() => {
    getClients()
    getCompany()
    getTypesCoins()
    getContractStatus()
    getRamos()

    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [])

  function viewModal() {
    setShowModal(true)
  }

  // console.log(JSON.parse(selectCreatedClient).nombre);

  ;<ClientWrapper>
    <InputSelect
      label="Nombre del cliente"
      name="cliente"
      options={nombreCliente}
      control={control}
      errorMessage={errors.cliente?.type}
      placeholder="Cliente"
      value={selectCreatedClient}
    />
    <NewClientButton onClick={viewModal}>+ Crear nuevo cliente</NewClientButton>
  </ClientWrapper>

  return (
    <>
      <ModalContainer
        showModal={clientCreated.view}
        closeModal={() =>{
          console.log();
          setClientCreated({ view: false, created: true, customMessage: "" })
        }}
      >
        <TextNotification created={clientCreated.created}>
          {" "}
          {clientCreated.created
            ? clientCreated.customMessage || "Cliente Agregado"
            : clientCreated.customMessage ||
              "Hubo un error, inténtelo de nuevo"}
        </TextNotification>
      </ModalContainer>
     
      <ModalContainer
        showModal={showModal}
        closeModal={() => setShowModal(false)}
      >
        <ModuleTitle>Agrega un nuevo cliente</ModuleTitle>
        <ModalForm
          showModal={showModal}
          setShowModal={setShowModal}
          title="Agrega un nuevo cliente"
          handleSubmitRef={handleSubmit2(onSubmitModal)}
          textButton="Agregar Cliente"
        >
          <InputText
            label={"Nombre del cliente"}
            type="text"
            placeholder={"Nombre"}
            name="nombre"
            control={control2}
            register={{ ...register2("nombre") }}
            errorMessage={errors2.nuevoCliente?.type}
          />
        </ModalForm>
      </ModalContainer>
      <Container>
        <Navbar />
        <RecentsWrapper>
          <RecentsContainer>
            <RecentsTitle>Agrega un contrato nuevo</RecentsTitle>
            <Divider />
            <NewContractContainer onSubmit={handleSubmit(onSubmit)}>
              <TitleContract>Nuevo</TitleContract>
              <FormContractContainer>
                <RowContainer>
                  <ClientWrapper>
                    <InputSelect
                      label="Nombre del cliente"
                      name="cliente_id"
                      optionData={allDataInputs}
                      options={nombreCliente}
                      control={control}
                      errorMessage={errors.cliente?.type}
                      placeholder="Cliente"
                      // value={selectCreatedClient}
                    />
                    <NewClientButton onClick={viewModal}>
                      + Crear nuevo cliente
                    </NewClientButton>
                  </ClientWrapper>
                  <InputSelect
                    label="Estatus"
                    name="estatus_contrato_id"
                    optionData={allDataInputs}
                    options={estatus}
                    control={control}
                    errorMessage={errors.estatus?.type}
                    placeholder="Estatus"
                  />
                  <InputNumber
                    prefix="$"
                    label="Suma asegurada"
                    name="sum"
                    type="number"
                    control={control}
                    placeholder="0"
                    register={{ ...register("sum") }}
                    errorMessage={errors.sum?.type}
                  />
                </RowContainer>
                <RowContainer>
                  <InputText
                    label="Número de contrato"
                    name="numeroContrato"
                    type="number"
                    control={control}
                    placeholder="Nº de contrato"
                    register={{ ...register("numeroContrato") }}
                    errorMessage={errors.numeroContrato?.type}
                  />
                  {errors.numeroContrato?.message}
                  <InputDatePicker
                    label="Fecha de emisión"
                    control={control}
                    name="fecha_emi"
                    errorMessage={errors.fechaEmision?.type}
                  />
                  <InputNumber
                    prefix="%"
                    label="% de participación"
                    name="porcentaje"
                    type="number"
                    control={control}
                    placeholder="0"
                    max={100}
                    maxLength={3}
                    register={{ ...register("porcentaje") }}
                    errorMessage={errors.porcentaje?.type}
                  />
                </RowContainer>
                <RowContainer>
                  <div>
                    <InputDatePicker
                      label="Vigencia del contrato"
                      control={control}
                      name="fecha_ini"
                      errorMessage={errors.inicioVigencia?.type}
                    />
                    <InputDatePicker
                      control={control}
                      name="fecha_fin"
                      errorMessage={errors.finalVigencia?.type}
                      onChange={(e) => console.log(e)}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 10,
                        alignItems: "center",
                        gap: 10
                      }}
                    >
                      <InputTime
                        control={control}
                        name="inicioHoraVigencia"
                        errorMessage={errors.inicioHoraVigencia?.type}
                      />
                      <InputTime
                        control={control}
                        name="finalHoraVigencia"
                        errorMessage={errors.finalHoraVigencia?.type}
                      />
                    </div>
                  </div>
                  <InputSelect
                    label="Ramo"
                    name="ramo_id"
                    optionData={allDataInputs}
                    options={ramos}
                    control={control}
                    errorMessage={errors.ramos?.type}
                    placeholder="Ramo"
                  />
                  <InputSelect
                    label="Moneda"
                    name="tipo_cambio_id"
                    optionData={allDataInputs}
                    options={divisas}
                    control={control}
                    errorMessage={errors.divisas?.type}
                    placeholder="USD/MXN"
                  />
                </RowContainer>
              </FormContractContainer>
              {window.innerWidth > 769 ? (
                <Button
                  text={"Proceder"}
                  style={{ margin: "0 46px", alignSelf: "flex-end" }}
                  type="submit"
                />
              ) : (
                <Button
                  text={"Proceder"}
                  style={{ width: "100%" }}
                  type="submit"
                />
              )}
            </NewContractContainer>
          </RecentsContainer>
        </RecentsWrapper>
      </Container>
      <Footer />
    </>
  )
}

const Container = styled.div`
  width: 100%;
  display: grid;
  justify-content: center;
  min-height: calc(100vh - 62px);
`

const NewContractContainer = styled.form`
  width: 100%;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 28px;
`

const RowContainer = styled.div`
  display: flex;
  gap: 50px;
  justify-content: space-between;
  & > div {
    width: 300px;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const ClientWrapper = styled.div``

const NewClientButton = styled.div`
  color: var(--primary-royal-blue);
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
`

const TitleContract = styled.h3`
  color: var(--primary-royal-blue);
  font-size: 24px;
  font-weight: 700;
`

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: var(--primary-pistachio);
`

const FormContractContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0px;
  transition: 200ms;
  gap: 20px;
  width: 100%;
`

const RecentsTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
`

const RecentsWrapper = styled.div`
  width: 100vw;
  display: grid;
  place-content: center;
  position: relative;
  margin-top: 50px;
  &:after {
    background-color: var(--primary-royal-blue);
    content: "";
    top: 0;
    height: 480px;
    width: 100%;
    position: absolute;
    z-index: -1;
  }
`

const RecentsContainer = styled.div`
  background-color: #fff;
  border-radius: 24px;
  padding: 40px;
  width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: rgba(99, 99, 99, 0.1) 0px 2px 4px 0px;
  margin-top: 50px;
  @media only screen and (max-width: 1280px) {
    width: 100vw;
    padding: 40px 20px;
  }

  @media only screen and (max-width: 768px) {
    padding: 40px;
    margin-top: 70px;
  }
`


const ModuleTitle = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
`

const TextNotification = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${({ created }) => (created ? "var(--primary-pistachio)" : "red")};
  margin: 0 20px;
`


